export const Bio = {
  name: "Tanish Moral",
  roles: [
    "an Android Developer",
    "an Open-Source Contributor",
    "a Golang Developer",
    "a Competitive Programmer",
  ],
  description:
    "Computer Science undergraduate at IIIT Lucknow with a passion for building impactful Android apps and contributing to open source. 2 times Intern at Google (as a Software Engineer Intern and Associate Software Developer Intern), with expertise in Kotlin, Java, Android SDK, Go, and system design. Enthusiastic about solving complex problems, mentoring peers, and creating scalable, user-focused solutions.",
  github: "https://github.com/TanishMoral11",
  resume:
    "",
  linkedin: "https://www.linkedin.com/in/tanishmoral/",
  twitter: "https://x.com/moral_tanish",
  insta: "https://www.instagram.com/tanishmoral11/"
};

export const skills = [
  {
    title: "Android",
    skills: [
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Jetpack Compose",
        image:
          "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjC97Z8BResg5dlPqczsRCFhP6zewWX0X0e7fVPG-G7PuUZwwZVsi9OPoqJYkgqT2h0FI95SsmWzVEgpt8b8HAqFiIxZ98TFtY4lE0b8UrtVJ2HrJebRwl6C9DslsQDl9KnBIrdHS6LtkY/s1600/jetpack+compose+icon_RGB.png",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {

    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://pngdownload.io/wp-content/uploads/2023/12/CSS-Logo-PNG-Symbol-for-Web-Development-Transparent-jpg.webp",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "React",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original-wordmark.svg",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "GOLANG",
        image:
          "https://go.dev/blog/go-brand/Go-Logo/PNG/Go-Logo_LightBlue.png"
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/9/9a/Visual_Studio_Code_1.35_icon.svg",
      },
      {
        name: "Postman",
        image:
          "https://user-images.githubusercontent.com/8083855/44999455-72444280-afce-11e8-9f22-fdd7259c637b.png",
      },
      {
        name: "Figma",
        image:
          "https://img.icons8.com/?size=100&id=zfHRZ6i1Wg0U&format=png&color=000000",
      },
      {
        name: "Linux",
        image:
          "https://img.icons8.com/?size=100&id=m6O2bFdG70gw&format=png&color=000000",
      },
      {
        name: "GitHub Actions",
        image:
          "https://github.githubassets.com/images/modules/site/features/actions-icon-actions.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://pngimg.com/uploads/google/google_PNG19644.png",
    role: "Software Engineer Intern",
    company: "Google",
    date: "May 2026 - July 2026",
    desc: [
      "Worked on the <span class=\"highlight\">Where is My Train</span> team to enhance the experience for 100M+ monthly users by building a client-side caching architecture in Kotlin and implementing offline live updates for platform numbers, train disruptions, and diverted routes.",
      "Built a scalable persistence layer using Jetpack Datastore and Protobuf, improving location and route accuracy for diverted trains and other dynamic live-status scenarios."
    ],
    skills: [
      "Kotlin",
      "Java",
      "Jetpack Compose",
      "Android SDK",
      "Jetpack Datastore",
      "Protobuf",
      "Blaze",
      "Firebase Remote Config",
      "Unit Testing"
    ],
    doc: "",
  },
  {
    id: 1,
    img: "https://pngimg.com/uploads/google/google_PNG19644.png",
    role: "Associate Software Developer Intern",
    company: "Google",
    date: "June 2025 - August 2025",
    desc: [
      "Designed and implemented a real-time query diffing mechanism for the Dynamic Groups system, previewing membership changes before submission to reduce configuration errors and improve deployment confidence.",
      "Built a scalable query translation layer in Java to combine CEL queries for membership evaluation, and developed the feature using Google’s internal Wiz MVC framework with JavaScript, Soy, SCSS, and Mendel."
    ],
    skills: ["Java", "JavaScript", "Wiz MVC", "Soy", "SCSS", "Mendel", "Blaze", "Google Cloud Platform"],
    doc: "",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcu6k17DUO5Q2jOTQ481ecy-Uc8IF_4lZQrg&s",
    role: "Android Developer (Open Source)",
    company: "Oppia Foundation",
    date: "September 2024 - March 2025",
    desc: [
      "Made 20+ Pull Requests (Contributions) to enhance UI/UX, improve app performance, and ensure scalability through bug fixes, performance optimizations, and feature enhancements.",
      "Wrote and maintained unit/UI tests, resolved 18+ issues, and collaborated with the team to improve app reliability, including critical fixes like splash screen responsiveness and crash prevention."
    ],
    skills: ["Android Development", "Bazel", "Kotlin"],
    doc: [
      { label: "Pull Requests", url: "https://github.com/oppia/oppia-android/pulls?q=is:pr+author:TanishMoral11+is:closed" },
      { label: "Resolved Issues", url: "https://github.com/oppia/oppia-android/issues?q=is%3Aissue%20state%3Aclosed%20assignee%3ATanishMoral11" }
    ]
  },
];


export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSwvjPSNRKawm-guKmpCMHAMo4v-DZSQes2XA&s",
    school: "Indian Institute of Information Technology, Lucknow",
    date: "August 2023 - June 2027",
    grade: "8.1/10 CGPA",
    desc: "I am currently pursuing a Bachelor of Technology in Computer Science & Engineering at the Indian Institute of Information Technology, Lucknow. My current CGPA is 8.1. I have been actively engaged in various academic and extracurricular activities, focusing on subjects such as Data Structures and Algorithms, Operating Systems, Object-Oriented Programming, and Database Management System.",
    degree: "Bachelor of Technology - B.Tech, Computer Science & Business",
  },
];


export const projects = [

  {
    "id": 0,
    "title": "College-Fix-It",
    "date": "September 2024",
    "description": "A smart complaint management app designed to simplify and streamline the student grievance process within college campuses.\n\n* Students can easily register and verify their accounts via Firebase Authentication or Google Sign-In.\n* Allows students to file complaints with clear titles and descriptions, visible to authorized guards or authorities.\n* Guards are registered through admin approval, ensuring only verified users can manage issues.\n* Implements a complaint voting system—students can upvote concerns they relate to, helping prioritize resolutions.\n* Real-time notifications alert guards as soon as a complaint is submitted.\n* Students can also manage and delete their own complaints if necessary.\n* Features a modern, dynamic UI with bottom navigation for intuitive access to Home, Add Complaint, and Profile sections.\n*",
    "image": "https://res.cloudinary.com/djwj4w9do/image/upload/v1755786021/college_fix_it_logo_gdizs3.png",
    "tags": ["Kotlin", "Android Development", "Firebase", "MVVM", "Retrofit", "Services", "Google Auth"],
    "category": "mobile app",
    "github": "https://github.com/TanishMoral11/College-Fix-It",
    "webapp": "https://github.com/TanishMoral11/College-Fix-It/releases/download/V1/app-debug.apk"
  },
  {
    "id": 1,
    "title": "Quizyy",
    "date": "October 2024",
    "description": "Quizyy is an AI-powered learning app designed to make studying smarter and more interactive. Students can upload images of lessons or notes, and the app generates a clear, easy-to-understand explanation of the content. From these explanations, Quizyy creates important and detailed questions, allowing students to generate personalized quizzes. By attempting these quizzes, learners can track their progress, check scores, and strengthen their understanding.",
    "tags": ["Android", "Kotlin", "Firebase", "Firestore", "Retrofit"],
    "category": "mobile app",
    "github": "https://github.com/TanishMoral11/Quizyy",
    "webapp": "",
    "image": "https://res.cloudinary.com/djwj4w9do/image/upload/v1755855261/Quizyy_logo_xf6h3w.png"
  }
];